/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface IAco {
  uuid?: string | null;
  id_barragem: string;
  empresa_avaliadora?: string;
  data_rco?: string;
  data_seminario: string;
  data_simulado?: string;
  data_dco?: string;
  status_dco?: string;
  responsavel_tecnico?: string;
  art?: string;
  naoConformidades: NaoConformidades[],
  recomendacoes: Recomandacoes[],
}

export interface NaoConformidades {
    nao_conformidade?: string,
    avaliacao?: string,
    id_aco?: string
}
export interface Recomandacoes {
    recomendacao?: string,
    prazo?: string,
}

const create = async (data: IAco): Promise<string | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('/aco', data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao criar novo ACO');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar novo ACO');
        }
    }
};

const list = async (uuid: string): Promise<IAco[] | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`/acos?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao listar ACOs');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao listar ACOs');
        }
    }
};

const get = async (uuid: string): Promise<IAco | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`/aco?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao buscar ACO');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar ACO');
        }
    }

};

const delet = async (uuid: string): Promise<string | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete(`/aco?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao listar ACO');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao listar ACO');
        }
    }
};


const upgrade = async (data: IAco, uuid: string): Promise<string | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`./aco?uuid=${uuid}`,data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao criar novo ACO');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar novo ACO');
        }
    }
};

export const AcoServices = {
    create,
    list,
    get,
    delet,
    upgrade
};